import React, { FC, useEffect, useRef, useState } from 'react'
import AccountIcon from 'svg/user-login.svg'
import styles from './Account.module.scss'
import AuthLinksDropDown from './AuthLinksDropDown'
import classNames from 'classnames'
import { useHeaderContext } from '../../HeaderContext'
import { useSelector } from 'react-redux'
import { getCheckIsMobileScreenWidth } from 'selectors/screen'
import { MAX_NAVBAR_MOBILE_WIDTH } from '../../navBreakpoints'

// Module scope so the memoized selector is created once
const getIsNavbarMobileWidth = getCheckIsMobileScreenWidth(MAX_NAVBAR_MOBILE_WIDTH)

const Authentication: FC = () => {
  const isMobileScreenWidth = useSelector(getIsNavbarMobileWidth)
  const { setMobileHeaderConfig } = useHeaderContext()
  const [dropdownIsOpen, handleDropdownOpen] = useState(false)
  const [dropdownIsHovered, setDropdownIsHovered] = useState(false)
  const authRef = useRef<HTMLDivElement>(null)

  const handleClick = () => {
    setDropdownIsHovered(false)

    // On mobile the links render inside the menu overlay instead of this dropdown
    if (!isMobileScreenWidth) {
      handleDropdownOpen((prevState) => !prevState)
      return
    }

    setMobileHeaderConfig((previousMobileHeaderConfig) => ({
      ...previousMobileHeaderConfig,
      mobileMenuContent: 'auth',
      mobileTopHeader: 'user',
      isMobileMenuOpen: true,
    }))
  }

  const handleDropdownHovered = (booleanFlag) => {
    return () => {
      if (!isMobileScreenWidth) {
        setDropdownIsHovered(booleanFlag)
      }
    }
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (authRef.current && !authRef.current.contains(event.target)) {
        handleDropdownOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div
      className={styles.accountDropDownMenu}
      onMouseEnter={handleDropdownHovered(true)}
      onMouseLeave={handleDropdownHovered(false)}
      onFocus={handleDropdownHovered(true)}
      onBlur={handleDropdownHovered(false)}
      data-type='auth-icon'
      ref={authRef}
    >
      <button
        type='button'
        className={classNames(styles.accountAuthIcon)}
        aria-label='authentication links'
        onClick={handleClick}
        data-type={`auth-icon${isMobileScreenWidth ? '-mobile' : ''}`}
      >
        <AccountIcon />
        <div
          data-type={`account-plus-icon${isMobileScreenWidth ? '-mobile' : ''}`}
          className={styles.accountPlusIcon}
        >
          +
        </div>
      </button>
      <AuthLinksDropDown dropdownIsOpen={dropdownIsOpen} dropdownIsHovered={dropdownIsHovered} />
    </div>
  )
}

export default Authentication
